import React from 'react';

import Option from '@hero/ui-kit/inputs/Option';

const processFilterOptions = (options: [string, string][]) =>
    options.map(([value, label]) => <Option key={value} value={value} labelText={label} />);

export default processFilterOptions;
